.container {
  display: flex;
  flex-direction: column;
}

.section-title {
  text-transform: uppercase;
  font-weight: 600;
  color: var(--chart-302-icon-buttons-titles);
  display: inline;
  line-height: calc(var(--spacer) * 4);
  cursor: default;
}

gz-text.text {
  color: var(--main-titles-inputs-600);
}

gz-labeled-content::part(label) {
  color: var(--body-text-arrows-300);
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
  font-size: var(--body-size-medium);
}

.icon-right-action {
  margin-left: 0;
  width: 32px;
  padding-right: 0;
}

.item-with-action {
  justify-content: space-between;
}

gz-labeled-content {
  margin-bottom: 6px;
}

.section-title {
  color: var(--chart-300-icon-buttons);
  font-weight: 600;

  &.bordered {
    border-top: 1px solid var(--grey-layout-chart-100);
  }
}

.finding-details-link::part(container) {
  padding: 0;
  --font-family: var(--font-family-secondary);
}

gz-tooltip {
  display: block;
}

.iconLabelBtn {
  height: auto;
  padding: 0;
  text-align: left;

  &:hover {
    background-color: transparent;
  }

  .category-titles {
    display: grid;
    --font-family: var(--font-family-secondary);

    .label {
      text-transform: none;
      text-align: left;
    }

    .secondary-label {
      font-size: var(--body-size-xsmall);
      text-transform: none;
      color: var(--chart-300-icon-buttons);
    }
  }
}

.show-more-findings {
  margin-left: auto;
  margin-top: var(--spacer);
  margin-bottom: var(--spacer);
}

#view-related-assets {
  margin-bottom: calc(var(--spacer) * 1.5);
}

gz-application-cve-list {
  border-top: 1px solid var(--grey-layout-chart-100);
  padding-top: calc(var(--spacer) * 1.5);
}

:host {
  color: var(--grey-layout-chart-100);
}
